import PropTypes from 'prop-types';

import React, { PureComponent } from 'react';

import BlockContent from './container';


export default class BlockContentWrapper extends PureComponent {
  static propTypes = {
    match: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  };

  render() {
    const { match } = this.props;
    const { match: { params: { blockVersionId } } } = this.props;

    return (
      <BlockContent key={blockVersionId} blockVersionId={blockVersionId} match={match} />
    );
  }
}
